export const gudaoLines = [
    {
        "id": 1,
        "name": "箬岭古道",
        "center": [
            29.980396,
            118.451787
        ],
        "zoom": 9.72,
        "points": [
            {
                "s_id": "1_1",
                "name": "许村古建筑群",
                "address": "歙县许村镇许村村",
                "desc": "许村古建筑群保存着元、明、清和民国时期的古建筑100余座，有高阳廊桥、五马坊等典型建筑。村落呈“二龙戏珠”“倒水葫芦”的风水形态，建筑种类多样，布局严谨，工艺精湛，是研究古代建筑史的重要实物资料，2006年被国务院公布为全国重点文物保护单位。",
                "thumbs": [
                    "gudao/marker/1_1/三朝典翰坊.JPG",
                    "gudao/marker/1_1/五马坊.JPG",
                    "gudao/marker/1_1/双寿承恩坊.JPG",
                    "gudao/marker/1_1/大观亭.JPG",
                    "gudao/marker/1_1/大郡伯第门楼.JPG",
                    "gudao/marker/1_1/薇省坊.JPG"
                ],
                "longitude": 118.326949,
                "latitude": 29.990672,
                "icon": "gudao/line/1/1.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.326949,
                "icon_latitude": 29.990672
            },
            {
                "s_id": "1_2",
                "name": "黄山茶林场场部大楼",
                "address": "黄山区谭家桥镇东黄山村知青小镇，距黄山茶林场社区北200米",
                "desc": "黄山茶林场场部大楼建于1960年，是3层红砖红瓦砖木仿苏建筑，原是省地方国营黄山茶林场为公安厅建的疗养院，后成为上海市黄山茶林场场部办公大楼。这里承载着知青文化与海派文化，见证了时代变迁，极具历史价值，2019年3月被安徽省政府公布为省级文物保护单位。",
                "thumbs": [
                    "gudao/marker/1_2/图片1.png",
                    "gudao/marker/1_2/图片2.png"
                ],
                "longitude": 118.291557,
                "latitude": 30.154581,
                "icon": "gudao/line/1/2.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.299601,
                "icon_latitude": 30.152248
            },
            {
                "s_id": "1_3",
                "name": "军博园",
                "address": "黄山区谭家桥镇中墩村",
                "desc": "2011年建成开放。以“铁血军魂”为主题，通过文物、图片、场景复原等，展现先遣队从组建到征战的历程，尤其突出谭家桥战斗史实。纪念馆与周边的战地医院、战壕遗址等构成红色纪念群，是全国爱国主义教育示范基地。",
                "thumbs": [
                    "gudao/marker/1_3/红军纪念珍贵藏品.JPG",
                    "gudao/marker/1_3/红军纪念珍贵藏品2.JPG",
                    "gudao/marker/1_3/陈列馆外景 (1).jpg"
                ],
                "longitude": 118.24949,
                "latitude": 30.141138,
                "icon": "gudao/line/1/3.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.101715,
                "icon_latitude": 30.141873
            }
        ]
    },
    {
        "id": 2,
        "name": "桃岭古道",
        "center": [
            30.030396,
            117.951787
        ],
        "zoom": 10.64,
        "points": [
            {
                "s_id": "2_1",
                "name": "弦歌里廊桥",
                "address": "黄山区焦村镇郭村村石下组",
                "desc": "弦歌里廊桥是黄山区保存完好的唯一廊桥。该桥建于明代，阁楼建于清代。建筑为一进三开间二层阁楼，面阔13米，进深6米，高7米，下有2米高、4米长、6米宽的石拱桥。阁面东南，巷棚硬山式，两旁有封火墙，木架结构为穿斗式。其东侧立有三块石碑，记载着修路、补桥等功德，具有较高的史料研究价值。",
                "thumbs": [
                    "gudao/marker/2_1/观世阁2.jpg",
                    "gudao/marker/2_1/观音阁1.jpg"
                ],
                "longitude": 117.920172,
                "latitude": 30.106618,
                "icon": "gudao/line/2/1.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 117.971766,
                "icon_latitude": 30.106618
            },
            {
                "s_id": "2_2",
                "name": "周王庙遗址",
                "address": "黄山区焦村镇郭村村石下组，桃林古道山腰，距郭村村委会北2300米",
                "desc": "据史料记载，郭村林姓于南宋时由福建迁入，因林氏之姓为周武王所赐，便在桃岭建周王庙，供奉周文王和周武王，以祈平安。遗址处已无残垣断壁，仅留碎砖瓦砾与散落条石，周边芭茅草、桃树丛生。遗址上立有两碑，记载着庙宇因战乱荒废后重建等事宜，其中郭村林姓在重建中贡献颇大。每年农历九月的周王会，村民会将庙中周王菩萨抬至村里巡游，热闹非凡，该庙会如今已成安徽省省级非物质文化遗产 。",
                "thumbs": [
                    "gudao/marker/2_2/周王庙会.JPG"
                ],
                "longitude": 117.963267,
                "latitude": 30.119634,
                "icon": "gudao/line/2/2.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.054214,
                "icon_latitude": 30.128403
            },
            {
                "s_id": "2_3",
                "name": "卢村建筑群",
                "address": "黟县宏村镇卢村",
                "desc": "卢村古建筑群始建于南唐，以卢姓聚居为主。村内古民居保存完好，最著名的是清道光年间卢帮燮建造的木雕楼群，包括志诚堂、思济堂等宅院。木雕楼雕刻技艺精湛，图案精美，题材丰富，有 “徽州木雕第一楼” 美誉。此外，驷车桥、村内水系等也极具特色，与古民居相互映衬，构成了一幅优美的皖南水乡画卷。",
                "thumbs": [
                    "gudao/marker/2_3/1.jpg",
                    "gudao/marker/2_3/2.jpg",
                    "gudao/marker/2_3/3.jpg"
                ],
                "longitude": 117.975501,
                "latitude": 30.014711,
                "icon": "gudao/line/2/3.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.048661,
                "icon_latitude": 30.002582
            },
            {
                "s_id": "2_4",
                "name": "宏村古建筑",
                "address": "黟县宏村镇宏村村",
                "desc": "宏村古建筑群是明、清、民国时期的徽州民居建筑群。它始建于南宋，已有 800 多年历史，为汪姓聚居地。村落呈牛形布局，水圳、月沼、南湖等水系贯穿其中。代表建筑有南湖书院、乐叙堂、承志堂等。建筑粉墙黛瓦，木雕、石雕、砖雕精美，具有深厚人文内涵，2000 年被列入世界文化遗产名录，2001 年成为全国重点文物保护单位。",
                "thumbs": [
                    "gudao/marker/2_4/图片3.png",
                    "gudao/marker/2_4/图片5.png"
                ],
                "longitude": 117.989956,
                "latitude": 30.002582,
                "icon": "gudao/line/2/4.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 117.938188,
                "icon_latitude": 30.002582
            }
        ]
    },
    {
        "id": 3,
        "name": "徽开古道",
        "center": [
            29.780396,
            118.451787
        ],
        "zoom": 8.85,
        "points": [
            {
                "s_id": "3_1",
                "name": "竹岭古亭",
                "address": "歙县三阳镇岭脚村（距离岭脚村村委会东侧侧1508米处）",
                "desc": "竹岭古亭是清代时期的木结构路亭建筑，日常用于行人休憩使用。2009年第三次全国文物普查将竹岭古亭登记为“尚未核定为文物保护单位的不可移动文物”。坐东朝西，平面布局呈矩形，一进三开间，通面阔4.87米，通进深9.04米，占地面积44.02平方米。该建筑为一层木构建筑，砖墙围护，屋架采用插梁与穿斗混合式木梁架，正贴五檩用两柱，中柱与金柱不落地，边帖五檩用四柱，中柱不落地。建筑屋面双坡硬山造，铺小青瓦，阴阳合瓦。山墙做马头墙样式，砖砌外墙抹草筋灰后刷白。该建筑西立面作为正立面，辟拱券形门洞，北立面拱券形门洞上方门额题有“昱岭在望”四个大字。",
                "thumbs": [
                    "gudao/marker/3_1/35481756264459_.pic_hd.jpg",
                    "gudao/marker/3_1/35491756264459_.pic_hd.jpg"
                ],
                "longitude": 118.862791,
                "latitude": 30.037607,
                "icon": "gudao/line/3/1.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.815045,
                "icon_latitude": 29.858592
            },
            {
                "s_id": "3_2",
                "name": "五里亭",
                "address": "休宁县白际乡",
                "desc": "五里亭为徽开古道上设置的茶亭，由浙江中洲人保成出资，岭脚村张锡开主持工程建造",
                "thumbs": [
                    "gudao/marker/3_2/WechatIMG69.jpg"
                ],
                "longitude": 118.398595,
                "latitude": 29.532459,
                "icon": "gudao/line/3/2.png",
                "icon_scale": 113,
                "wh": 1.424,
                "icon_longitude": 118.168945,
                "icon_latitude": 29.528060
            },
            {
                "s_id": "3_3",
                "name": "百丈冲瀑布",
                "address": "休宁县白际乡严池村",
                "desc": "黄山市休宁县百丈冲瀑布位于白际乡严池村原始山林中，未被过度开发，以满眼青绿和天然景观为特色。雨季时，瀑布从几十米高的石峰凌空而下，形成“青龙吐涎”的壮观景象，山风将水流撕成千丝万缕，如同天马扬尾，带来独特视觉体验。",
                "thumbs": [
                    "gudao/marker/3_3/2.jpg",
                    "gudao/marker/3_3/wKiM92RIkzeAdDN6AAYU3IOsYd0915.jpg"
                ],
                "longitude": 118.418069,
                "latitude": 29.518811,
                "icon": "gudao/line/3/3.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.418069,
                "icon_latitude": 29.518811
            }
        ]
    },
    {
        "id": 4,
        "name": "霞客古道",
        "center": [
            29.780396,
            118.11787
        ],
        "zoom": 11,
        "points": [
            {
                "s_id": "4_1",
                "name": "“向云端”观光列车微公园",
                "address": "休宁县齐云山镇张村53号",
                "desc": "向云端由一段废弃公路华丽转身而来，摇身成为“向云端・世界观光列车微公园”。公园内，威尼斯东方快车、南非蓝色列车等十大观光列车1:1复刻车厢串联，充满异域风情。车厢摇身变为美术馆、稻田咖啡馆等特色空间。周边水杉高耸，江畔林荫与落日唯美，是一处集休闲、打卡、体验多元文化于一体的宝藏地，也是齐云山文旅创新的网红打卡点 。",
                "thumbs": [
                    "gudao/marker/4_1/1.jpg",
                    "gudao/marker/4_1/2.jpg"
                ],
                "longitude": 118.084398,
                "latitude": 29.810801,
                "icon": "gudao/line/4/1.png",
                "icon_scale": 113,
                "wh": 1.797,
                "icon_longitude": 118.177134,
                "icon_latitude": 29.803707
            },
            {
                "s_id": "4_2",
                "name": "齐云山风景区",
                "address": "休宁县城西约15公里处",
                "desc": "齐云山风景区面积110公里，自然保护区面积150公里，由齐云、白岳、歧山、万寿等9座山峰组成。",
                "thumbs": [
                    "gudao/marker/4_2/1.jpg",
                    "gudao/marker/4_2/2.jpg",
                    "gudao/marker/4_2/3.jpg"
                ],
                "longitude": 118.036434,
                "latitude": 29.809262,
                "icon": "gudao/line/4/2.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.098961,
                "icon_latitude": 29.792346
            },
            {
                "s_id": "4_3",
                "name": "齐云小镇",
                "address": "休宁县齐云山风景名胜区齐云小镇",
                "desc": "齐云小镇以文旅、游憩和竞技三大主题为标准，成为了很多文旅爱好者和艺术家的集散地。在这方小镇街区之中，徽派与现代建筑完美融合，让人在城市之外，放下世事的纷扰，感受一份归园田居的生活。",
                "thumbs": [
                    "gudao/marker/4_3/1.jpg"
                ],
                "longitude": 118.036434,
                "latitude": 29.809262,
                "icon": "gudao/line/4/3.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.036434,
                "icon_latitude": 29.762281
            },
            {
                "s_id": "4_4",
                "name": "自由家营地",
                "address": "休宁县齐云山月华索道西侧180米",
                "desc": "齐云山自由家营地占地500亩，以生态树屋为特色，60多间造型各异的树屋隐匿林间。营地设有20余项特色体验项目，如高空探险、迷你高尔夫等。还有爱萌乐园，可与多种萌宠亲密互动。此外，营地餐厅提供多种地道美食。无论是家庭亲子游，还是情侣度假、户外爱好者探险，都能在此享受独特的野奢体验，感受大自然的美好。",
                "thumbs": [
                    "gudao/marker/4_4/1.jpg"
                ],
                "longitude": 118.043227,
                "latitude": 29.820415,
                "icon": "gudao/line/4/4.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.043227,
                "icon_latitude": 29.820415
            }
        ]
    },
    {
        "id": 5,
        "name": "徽饶古道",
        "center": [
            29.680396,
            118.151787
        ],
        "zoom": 10.38,
        "points": [
            {
                "s_id": "5_1",
                "name": "梓坞祠堂",
                "address": "休宁县板桥镇梓坞村",
                "desc": "梓坞祠堂是省级重点文物保护单位。它始建于明代，是“梓里思昭公之家庙”。祠堂为三进三开间格局，面积约450平方米，坐东南朝西北，整体建筑包括门屋、享堂、寝楼。其门罩、雀替、平盘斗等部位的砖雕、木雕精美，梁架采用抬梁式结构。对于研究当地宗族文化及徽派雕刻、建筑艺术的重要实物史料有重要价值。",
                "thumbs": [
                    "gudao/marker/5_1/35501756264870_.pic_hd.jpg",
                    "gudao/marker/5_1/35511756264870_.pic_hd.jpg"
                ],
                "longitude": 117.922035,
                "latitude": 29.585814,
                "icon": "gudao/line/5/1.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 117.929698,
                "icon_latitude": 29.690841
            },
            {
                "s_id": "5_2",
                "name": "板桥乡状元鱼王",
                "address": "休宁县板桥镇梓坞村",
                "desc": "1970年，板桥乡梓坞村村民汪长生夫妇喜迎女儿诞生，将数尾半斤重的草鱼鱼苗放入自家山泉鱼塘，其中一尾鱼苗历经五十余载的风雨洗礼，顽强存活至今，以55岁的高龄打破了草鱼平均7— 8年的寿命常规，成为国内罕见的“长寿鱼王”，其长寿程度相当于人类的150岁 。如今，这条鱼王体长近1.4米，体重超35公斤，堪称鱼中 “巨无霸”。目前，这条鱼王已然成为梓坞村的网红打卡点，不仅见证了休宁县在生态保护与特色产业发展方面的显著成效，还生动诠释了 “绿水青山就是金山银山” 的发展理念 。",
                "thumbs": [
                    "gudao/marker/5_2/微信图片_2025-08-25_161759_511.jpg",
                    "gudao/marker/5_2/微信图片_2025-08-25_161810_104.jpg"
                ],
                "longitude": 117.927021,
                "latitude": 29.583179,
                "icon": "gudao/line/5/2.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 117.927021,
                "icon_latitude": 29.583179
            },
            {
                "s_id": "5_3",
                "name": "800年红豆杉古树",
                "address": "休宁县板桥镇梓坞村",
                "desc": "梓坞村有株胸径1.35米、树高达22米的红豆杉古树，冠幅20米，树龄500多年。在树的根部，有一块高约1.5米的古墓碑被树根紧紧包围，碑的的下方已完全包入了古树根部，形成了古树抱古碑的景观，见证着岁月的沧桑和古树的力量。",
                "thumbs": [
                    "gudao/marker/5_3/微信图片_2025-08-25_161739_397.jpg",
                    "gudao/marker/5_3/微信图片_2025-08-25_161747_912.jpg"
                ],
                "longitude": 117.927021,
                "latitude": 29.583179,
                "icon": "gudao/line/5/3.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 118.036005,
                "icon_latitude": 29.573266
            },
            {
                "s_id": "5_4",
                "name": "仰题桥",
                "address": "休宁县板桥乡梓坞村里梓坞村民（距梓坞村村委会北方向约800米）",
                "desc": "仰题桥始建于清代，是徽州地区保存较完整的单孔石拱廊桥。该桥东西走向，原建桥上长廊已毁，现存长廊为20世纪末重建。桥梁全长15.81米，宽4.19米，采用块石纵联砌筑工艺，拱券高0.45米。桥体比例协调，拱券曲线优美流畅，砌筑工艺精湛。作为徽州廊桥典型代表，反映清代交通设施与公共空间的营造理念，具有很高的历史、艺术、科学价值。",
                "thumbs": [
                    "gudao/marker/5_4/35521756265046_.pic_hd.jpg",
                    "gudao/marker/5_4/35531756265046_.pic.jpg"
                ],
                "longitude": 117.920929,
                "latitude": 29.593255,
                "icon": "gudao/line/5/4.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 118.076943,
                "icon_latitude": 29.663780
            },
            {
                "s_id": "5_5",
                "name": "同春亭",
                "address": "休宁县板桥乡樟前行政村浙岭山顶",
                "desc": "同春亭始建于清乾隆年间，是徽饶古道吴楚分源处的标志性石亭，现存主体为清代遗构。现作为休婺古道上的重要景点开放。作为徽饶古道的见证，该亭兼具交通节点与人文地标功能，其石砌技艺和碑刻文献为探讨徽州古道文化、清代石构建筑技艺及地域社会史提供了珍贵依据，具有突出的历史、科学与社会价值。",
                "thumbs": [
                    "gudao/marker/5_5/35541756265066_.pic_hd.jpg",
                    "gudao/marker/5_5/35551756265066_.pic_hd.jpg",
                    "gudao/marker/5_5/35561756265066_.pic_hd.jpg"
                ],
                "longitude": 117.908827,
                "latitude": 29.555098,
                "icon": "gudao/line/5/5.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 118.037124,
                "icon_latitude": 29.717635
            }
        ]
    },
    {
        "id": 6,
        "name": "徽池古道",
        "center": [
            30.030396,
            117.961781
        ],
        "zoom": 10.35,
        "points": [
            {
                "s_id": "6_1",
                "name": "柯村暴动纪念馆等红色场馆群",
                "address": "黄山市黟县柯村镇",
                "desc": "村暴动纪念馆等红色场馆群位于黄山市黟县柯村镇，以柯村暴动为历史背景。核心场馆柯村暴动纪念馆，通过文物、图片等展现 1934 年柯村暴动及皖南苏维埃政权建立历程。周边有皖南苏维埃政府旧址（柯氏宗祠）、红军医院、列宁小学等遗址场馆，构成完整红色记忆链条。这里是安徽省爱国主义教育基地，见证了皖南地区革命斗争历史，成为传承红色基因的重要载体。",
                "thumbs": [
                    "gudao/marker/6_1/柯村暴动纪念馆1.jpg",
                    "gudao/marker/6_1/柯村暴动纪念馆2.jpg",
                    "gudao/marker/6_1/柯村暴动纪念馆3.jpg"
                ],
                "longitude": 117.752478,
                "latitude": 30.10919,
                "icon": "gudao/line/6/1.png",
                "icon_scale": 113,
                "wh": 1.797,
                "icon_longitude": 117.782478,
                "icon_latitude": 30.10919
            },
            {
                "s_id": "6_2",
                "name": "琅山庵红军学校",
                "address": "黟县柯村镇宝溪村",
                "desc": "琅山庵红军学校原是庵堂，清末、民国时被兴办为私塾。1931年冬，共产党员王和生到此任教，借机宣传马克思主义思想。1934年柯村暴动成功后成为红军学校，也是下辖五个区委的集中训练班开办地。中共太平中心县委书记刘毓标等众多干部亲自到校讲课，开设了土地、干部、工会等多个训练班，为苏区培养了大批革命骨干。",
                "thumbs": [
                    "gudao/marker/6_2/红军学校 (2).jpg",
                    "gudao/marker/6_2/红军学校 (3).jpg",
                    "gudao/marker/6_2/红军学校 (4).jpg"
                ],
                "longitude": 117.672661,
                "latitude": 30.093053,
                "icon": "gudao/line/6/2.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 117.672661,
                "icon_latitude": 30.093053
            },
            {
                "s_id": "6_3",
                "name": "翠林村",
                "address": "黟县柯村镇翠林村",
                "desc": "宋朝末年建村，四面环山，山峦重叠，连成一体，成一圆形，形似一片荷叶，村庄犹如荷叶中托着一只“神龟”。村庄内传统建筑、文物古迹众多，老祠堂、古民居、老井和古树等错落有致。",
                "thumbs": [
                    "gudao/marker/6_3/BB67C6D446D6A7D745EB93A7D3E66D26.jpg",
                    "gudao/marker/6_3/传统村落 (2).jpg",
                    "gudao/marker/6_3/微信图片_20230325223528.jpg"
                ],
                "longitude": 117.69074,
                "latitude": 30.091191,
                "icon": "gudao/line/6/3.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 117.761369,
                "icon_latitude": 30.028342
            }
        ]
    },
    {
        "id": 7,
        "name": "祁黟古道",
        "center": [
            29.890396,
            117.851787
        ],
        "zoom": 11.15,
        "points": [
            {
                "s_id": "7_1",
                "name": "关麓古建筑群",
                "address": "黟县碧阳镇关麓村",
                "desc": "关麓古建筑群是徽派古村落的典型代表。村落始建于五代，以汪姓聚居为主，因地处古徽州通往池州的要道而得名。村内保存着大量明清时期古民居，尤以“八大家”连体建筑群闻名。这八座宅院相互联通又各自独立，门楼风格各异，砖雕、木雕精美细腻。此外，还有双桂堂、吾爱吾庐等特色建筑，布局严谨，体现了徽商文化与宗族制度的印记，是研究徽州民居建筑与社会结构的重要实物。",
                "thumbs": [
                    "gudao/marker/7_1/1.jpg",
                    "gudao/marker/7_1/2.jpg"
                ],
                "longitude": 117.869917,
                "latitude": 29.894736,
                "icon": "gudao/line/7/1.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 117.869917,
                "icon_latitude": 29.894736
            },
            {
                "s_id": "7_2",
                "name": "观音桥",
                "address": "祁门县柏溪乡西溶村西黄组S477公路北侧100米处",
                "desc": "观音桥建于清代，系村中过溪行走之道。观音桥呈东西走向，单孔拱桥，青石砌筑桥身，拱圈以长条石等大块石材横列环砌。桥拱北侧中部有桥名碑“观音桥”辛卯年冬月运德堂修造，桥拱南侧中部有石碑刻字“赤桥”辛卯年冬月运德堂修造。桥面采用大块青石板铺设，现有部分破损或改建。为方便取水，桥身西北侧及西南侧各设有石阶而下至溪边平台。该桥西侧为村中道路十字交口，东侧道路通往村组东部民宅，东南侧为树林。观音桥桥名“观音”，反映了佛教等宗教信仰在徽州地区民间具有普遍性这一事实，以实物体现了徽州文化及艺术遗存。观音桥长8.7米，宽3.5米，高度2.6米，跨度4.46米，占地面积30平方米。",
                "thumbs": [
                    "gudao/marker/7_2/35591756265186_.pic_hd.jpg",
                    "gudao/marker/7_2/35601756265186_.pic_hd.jpg"
                ],
                "longitude": 117.830068,
                "latitude": 29.894358,
                "icon": "gudao/line/7/2.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 117.806284,
                "icon_latitude": 29.891333
            },
            {
                "s_id": "7_3",
                "name": "柏溪廊桥",
                "address": "祁门县柏溪乡柏溪村下街的柏溪河上",
                "desc": "柏溪廊桥又名钟秀桥，建于乾隆四十八年（1783年），为三孔红麻石构造，桥长 28.3米，宽5米，高7米。桥身正中刻有“钟秀桥”三字，古朴苍劲。其船形桥墩设计独特，能有效抵御水流冲击。梁上木雕精美，栏杆刻有吉祥图案。作为市文物保护单位，它不仅是重要交通设施，更是村民情感寄托，承载着当地的历史文化与风土人情。",
                "thumbs": [
                    "gudao/marker/7_3/35611756265214_.pic_hd.jpg",
                    "gudao/marker/7_3/35621756265214_.pic_hd.jpg",
                    "gudao/marker/7_3/35631756265214_.pic_hd.jpg"
                ],
                "longitude": 117.806284,
                "latitude": 29.895007,
                "icon": "gudao/line/7/3.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 117.759872,
                "icon_latitude": 29.871339
            },
            {
                "s_id": "7_4",
                "name": "明代门坊群",
                "address": "祁门县柏溪乡柏溪村",
                "desc": "明代门坊群包括郎官第门坊、赐进士第门坊、敬典堂门坊及科举坊，2023年被评为祁门县县级文物保护单位。",
                "thumbs": [
                    "gudao/marker/7_4/35641756265307_.pic_hd.jpg",
                    "gudao/marker/7_4/35651756265307_.pic_hd.jpg",
                    "gudao/marker/7_4/35661756265308_.pic_hd.jpg",
                    "gudao/marker/7_4/35671756265308_.pic_hd.jpg"
                ],
                "longitude": 117.802672,
                "latitude": 29.88671,
                "icon": "gudao/line/7/4.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 117.705546,
                "icon_latitude": 29.901409
            }
        ]
    },
    {
        "id": 8,
        "name": "大洪岭古道",
        "center": [
            29.990396,
            117.851787
        ],
        "zoom": 10.20,
        "points": [
            {
                "s_id": "8_1",
                "name": "安阜廊桥",
                "address": "祁门县大坦乡大坦河上",
                "desc": "安阜廊桥建于明嘉靖年间。桥长30余米，分上下两部分，下半部是石质单孔石桥，上半部为粉墙黛瓦的廊屋。桥孔有“安阜桥”3字石刻，入门处门额题有 “东维揽秀”“西俪昭华” 横额。桥廊墙上设什锦花窗，造型为葫芦、六角等，意寓祥和。桥西首有 2 层楼阁，曾挂有风铃。作为明代徽州廊桥，它古朴秀美，承载着村民对安定富足生活的期盼。",
                "thumbs": [
                    "gudao/marker/8_1/WechatIMG3536.jpg",
                    "gudao/marker/8_1/WechatIMG3537.jpg"
                ],
                "longitude": 117.757347,
                "latitude": 29.943014,
                "icon": "gudao/line/8/1.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 117.501213,
                "icon_latitude": 29.943014
            },
            {
                "s_id": "8_2",
                "name": "阊江",
                "address": "祁门县大坦乡",
                "desc": "阊江出自大洪岭深处，全长79.8公里，是祁门境内第一大河。它一路接纳众多支流，流经塔坊镇、平里镇等地。在倒湖村与大北河交汇后，进入江西浮梁县，改称昌江。阊江是祁门的母亲河，河水滋养着沿岸土地，孕育了灿烂的地域文化。",
                "thumbs": [
                    "gudao/marker/8_2/1.jpg"
                ],
                "longitude": 117.757347,
                "latitude": 29.943014,
                "icon": "gudao/line/8/2.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 117.611347,
                "icon_latitude": 29.943014
            },
            {
                "s_id": "8_3",
                "name": "大洪庙遗址",
                "address": "祁门县大坦乡",
                "desc": "大洪庙遗址坐落于大洪岭，曾是行人往来的重要地标，周边存有清道光元年重修大洪岭时的碑刻，其上记载着修路事迹、捐款详情等。岭上还能觅得古战壕遗迹，见证着往昔兵家必争的险要。漫步于此，能透过遗址，遥想当年大洪庙的模样，感受岁月变迁与历史沧桑 。",
                "thumbs": [
                    "gudao/marker/8_3/35401756264281_.pic_hd.jpg",
                    "gudao/marker/8_3/35411756264281_.pic_hd.jpg"
                ],
                "longitude": 117.757347,
                "latitude": 29.943014,
                "icon": "gudao/line/8/3.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 117.747347,
                "icon_latitude": 29.943014
            },
            {
                "s_id": "8_4",
                "name": "雷湖胡氏宗祠",
                "address": "祁门县安凌镇雷湖村",
                "desc": "雷湖胡氏总祠始建于明代崇祯年间。其占地面积达1600余平方米，规模宏大，分仪门、享堂、寝堂三部分。主体结构采用抬梁式，两侧廊庑则为穿斗式梁架，面阔五间。祠内108根木柱落地，有“一百单八将”之称，地面以青石板铺设。梁枋、斜撑、雀替等构件上，雕刻着戏剧人物、花卉、动物及福、禄、寿、禧等精美图案 。1934年还曾作为工农红军革命根据地的指挥和办公场所，现为县级重点文物保护单位。",
                "thumbs": [
                    "gudao/marker/8_4/35381756264254_.pic_hd.jpg",
                    "gudao/marker/8_4/35391756264257_.pic_hd.jpg"
                ],
                "longitude": 117.68082,
                "latitude": 30.056915,
                "icon": "gudao/line/8/4.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 117.68082,
                "icon_latitude": 30.056915
            }
        ]
    },
    {
        "id": 9,
        "name": "汤岭古道",
        "center": [
            30.070396,
            118.151787
        ],
        "zoom": 10.81,
        "points": [
            {
                "s_id": "9_1",
                "name": "温泉拱券",
                "address": "黄山区汤口镇黄山风景区温泉景区公路北侧（名泉桥北侧20米）",
                "desc": "汤池拱券，建于明嘉靖年间（1521-1566），长6.2米，宽3.2米，高2.4米。“嵩阳若与黄山并，犹欠灵砂一道泉。”拱券下即温泉古泉眼所在。拱券处及后方岩壁多见宋元以降名人题刻。",
                "thumbs": [
                    "gudao/marker/9_1/35681756265367_.pic_hd.jpg",
                    "gudao/marker/9_1/35691756265367_.pic_hd.jpg"
                ],
                "longitude": 118.169108,
                "latitude": 30.10375,
                "icon": "gudao/line/9/1.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.200324,
                "icon_latitude": 30.032538
            },
            {
                "s_id": "9_2",
                "name": "小补桥及翼然亭",
                "address": "黄山区汤口镇黄山风景区温泉景区公路西北侧（名泉桥西北侧30米）",
                "desc": "小补桥及翼然亭，横跨汤泉溪。游人至此可小补揽胜之兴，故名。始建于明代，清乾隆五年（1740）毁于山洪，道光四年（1824）重建，为双孔平桥。1956年6月，南段石桥毁于山洪，现存北段悬臂石梁桥，长10.4米，高4.4米。翼然亭，建于中心桥墩之上，亭高4.1米，四柱飞檐形制，1965年董必武题名。1939年3月间，周恩来曾于小补桥处留影，照片为叶挺所摄。",
                "thumbs": [
                    "gudao/marker/9_2/35701756265401_.pic_hd.jpg",
                    "gudao/marker/9_2/35711756265402_.pic_hd.jpg"
                ],
                "longitude": 118.168891,
                "latitude": 30.103723,
                "icon": "gudao/line/9/2.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.176859,
                "icon_latitude": 30.099339
            },
            {
                "s_id": "9_3",
                "name": "白龙桥",
                "address": "黄山区汤口镇黄山风景区温泉景区登山道路南侧（黄山艺术馆北侧50米处）",
                "desc": "白龙桥，横跨白云溪、桃花溪汇合之汤泉溪，因近白龙潭得名。始建于民国二十三年（1934）。林森题额。花岗岩单拱桥，长21米，宽5.2米，高9.8米。桥南有龙头石，“龙头”二字1965年董必武题。",
                "thumbs": [
                    "gudao/marker/9_3/35721756265443_.pic_hd.jpg",
                    "gudao/marker/9_3/35731756265443_.pic_hd.jpg"
                ],
                "longitude": 118.166434,
                "latitude": 30.104668,
                "icon": "gudao/line/9/3.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.124591,
                "icon_latitude": 30.061637
            },
            {
                "s_id": "9_4",
                "name": "汤岭关",
                "address": "黄山区汤口镇黄山风景区洗药桥至白云庵登山道路上，汤岭岭头云门峰与云际峰之间山谷内（云际峰东北方向230米）",
                "desc": "汤岭关，位于汤岭头，云门峰与云际峰之间，磴道中穿而过，为“歙太两邑孔道，有万夫莫开之势。”始建于1859年，“以御粤寇。”二十世纪八十年代末重修。关墙向两翼峭壁延伸，花岗岩条石砌筑，总长31.7米，关顶设有垛堞和瞭望台。关门通高4.92米，阔2米，深4.6米，两侧嵌青石镌额“汤岭关”，款署“咸丰己未孟冬月，泾阳张芾立，华亭王桐监造。”",
                "thumbs": [
                    "gudao/marker/9_4/35741756265469_.pic_hd.jpg",
                    "gudao/marker/9_4/35751756265469_.pic_hd.jpg"
                ],
                "longitude": 118.149739,
                "latitude": 30.117881,
                "icon": "gudao/line/9/4.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.08232,
                "icon_latitude": 30.116677
            },
            {
                "s_id": "9_5",
                "name": "白云庵",
                "address": "黄山区焦村镇黄山风景区钓桥景区停车场至汤岭关登山道路途中（续古桥北侧40米）",
                "desc": "白云庵又名钓桥庵。明代为道院，康熙初年（1662）僧神立改建为庵。其后兴替无常，半修半圮。现存建筑，西北朝向，徽州民居形制，两进三开间，内设天井，左侧为厨房，建筑面积207平方米。花岗岩条石、青砖墙体，木构屋架，屋面盖小青瓦。拱形正门镌“白云庵”隶书额。",
                "thumbs": [
                    "gudao/marker/9_5/35761756265499_.pic_hd.jpg",
                    "gudao/marker/9_5/35771756265499_.pic_hd.jpg",
                    "gudao/marker/9_5/35781756265500_.pic_hd.jpg"
                ],
                "longitude": 118.125575,
                "latitude": 30.133401,
                "icon": "gudao/line/9/5.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.244014,
                "icon_latitude": 30.137741
            },
            {
                "s_id": "9_6",
                "name": "永定桥",
                "address": "黄山区焦村镇黄山风景区钓桥景区停车场至白云庵登山道路上（白云庵西北侧100米）",
                "desc": "永定桥位于白云庵前下约百米。始建于1495年，名延寿桥。约上世纪八十年",
                "thumbs": [
                    "gudao/marker/9_6/35791756265536_.pic_hd.jpg",
                    "gudao/marker/9_6/35801756265536_.pic_hd.jpg"
                ],
                "longitude": 118.131073,
                "latitude": 30.131129,
                "icon": "gudao/line/9/6.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.160164,
                "icon_latitude": 30.159322
            }
        ]
    },
    {
        "id": 10,
        "name": "文昌古道",
        "center": [
            29.780396,
            118.451787
        ],
        "zoom": 9.93,
        "points": [
            {
                "s_id": "10_1",
                "name": "百步云梯",
                "address": "歙县境内的岔口镇文山村至昌溪乡的徒步线路上",
                "desc": "文昌古道，最早修建始于民国五年（1916年），堪称徽州古道建筑的典范。整条古道全部由精细加工的青石板铺就，古道的坡度设计极具科学性，特别是\"百步云梯\"段，百余个石阶依悬崖砌就，呈优美的弧形绕过山坳，形似\"弹奏中的琴键\"，既保证了安全性，又创造了视觉美感。",
                "thumbs": [
                    "gudao/marker/10_1/石板路  .JPG",
                    "gudao/marker/10_1/石板路 .JPG"
                ],
                "longitude": 118.698497,
                "latitude": 29.886924,
                "icon": "gudao/line/10/1.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 118.805310,
                "icon_latitude": 29.939049
            },
            {
                "s_id": "10_2",
                "name": "文山村观音庙",
                "address": "歙县岔口镇文山村村委会西北侧约172米处",
                "desc": "文山村观音庙始建于清代，后于2020年村中集资重新修缮，故现状保存较为完好。该建筑一直都是作为村里祈福祭拜场所使用，一进三开间式砖木厅堂，块石砌筑台基。建筑通面阔6.08米，总进深5.63米，总占地面积34.23平方米。建筑南立面敞开为主入口，东西两侧山墙做观音兜文山村观音庙为村民祭拜祈福场所，承载了该村村民对未来生活的美好期待，具有一定的社会文化价值，该建筑结构稳固，小巧精致，具有一定的历史、艺术、科学价值。",
                "thumbs": [
                    "gudao/marker/10_2/微信图片_20250825103746.jpg"
                ],
                "longitude": 118.68811,
                "latitude": 29.892187,
                "icon": "gudao/line/10/2.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 118.694528,
                "icon_latitude": 29.888881
            },
            {
                "s_id": "10_3",
                "name": "阳产土楼",
                "address": "歙县深度镇阳产村",
                "desc": "阳产土楼是皖南少见的土楼群，百余座土楼依山而建，错落有致，全以黄土夯筑而成，墙厚窗小，冬暖夏凉。屋顶覆青瓦，呈“人”字形，利于排水。楼群巷道蜿蜒，石阶相连，保留着原始村落风貌。清晨薄雾缭绕，土楼若隐若现；秋日晒秋时节，玉米、辣椒挂满楼前，色彩斑斓。作为徽州山民智慧的结晶，阳产也被誉为“皖南土楼第一村”",
                "thumbs": [
                    "gudao/marker/10_3/1.jpg"
                ],
                "longitude": 118.662089,
                "latitude": 29.872949,
                "icon": "gudao/line/10/3.png",
                "icon_scale": 113,
                "wh": 1.425,
                "icon_longitude": 118.590443,
                "icon_latitude": 29.847427
            }
        ]
    },
    {
        "id": 11,
        "name": "西宏古道",
        "center": [
            29.960396,
            118.031787
        ],
        "zoom": 11.3,
        "points": [
            {
                "s_id": "11_1",
                "name": "西递村古建筑群",
                "address": "黟县西递镇西递村",
                "desc": "西递古建筑群位于安徽省黟县城东7公里。该村东西长700米，南北宽300米 。西递村始建于北宋，已有950年的历史。西递村是以宗族血缘关系为纽带，胡姓聚族而居的古村落，历史上较少受到战乱侵袭，也未受到经济发展冲击，村落原始形态保存完好。村中街巷沿溪而设，均用青石铺地，街巷两旁的古建筑淡雅朴素，错落有致，木雕、石雕、砖雕丰富多彩，巷道、溪流、建筑布局相宜。 西递村中保存完好明清民居近二百幢，是徽派古民居建筑艺术典范。",
                "thumbs": [
                    "gudao/marker/11_1/1.png",
                    "gudao/marker/11_1/2.png"
                ],
                "longitude": 117.99599,
                "latitude": 29.90334,
                "icon": "gudao/line/11/1.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 117.99599,
                "icon_latitude": 29.90334
            },
            {
                "s_id": "11_2",
                "name": "鸳鸯谷风景区",
                "address": "黟县西递镇潭口村",
                "desc": "鸳鸯谷毗邻世界文化遗产西递村约4公里。峡谷占地面积20平方公里，核心景观由白乐湖、石井、仙人桥、膺峰崖四大景区组成，分布仙人桥、虎跳岩、潜龙峰等50余处自然景点。谷内河滩存有二三十个潭池，绝壁存有二三十个深洞，溪水因两岸青山倒映呈碧绿色，因常见成双鸳鸯游动而得名",
                "thumbs": [
                    "gudao/marker/11_2/1.jpg"
                ],
                "longitude": 118.02011,
                "latitude": 29.932339,
                "icon": "gudao/line/11/2.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.02011,
                "icon_latitude": 29.932339
            },
            {
                "s_id": "11_3",
                "name": "宏村古建筑",
                "address": "黟县宏村镇宏村村",
                "desc": "宏村古建筑群是明、清、民国时期的徽州民居建筑群。它始建于南宋，已有 800 多年历史，为汪姓聚居地。村落呈牛形布局，水圳、月沼、南湖等水系贯穿其中。代表建筑有南湖书院、乐叙堂、承志堂等。建筑粉墙黛瓦，木雕、石雕、砖雕精美，具有深厚人文内涵，2000 年被列入世界文化遗产名录，2001 年成为全国重点文物保护单位。",
                "thumbs": [
                    "gudao/marker/11_3/1.jpg",
                    "gudao/marker/11_3/2.jpg"
                ],
                "longitude": 117.989956,
                "latitude": 30.002582,
                "icon": "gudao/line/11/3.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 117.989956,
                "icon_latitude": 30.002582
            }
        ]
    },
    {
        "id": 12,
        "name": "通灵古道",
        "center": [
            29.910396,
            118.351787
        ],
        "zoom": 11.9,
        "points": [
            {
                "s_id": "12_1",
                "name": "蜀源牌坊群",
                "address": "徽州区潜口镇蜀源村",
                "desc": "蜀源牌坊群由赞宪坊、贞寿之门坊、节孝坊三座明清石牌坊组成，是徽派牌坊建筑的杰出代表，承载着丰富的历史文化内涵。",
                "thumbs": [
                    "gudao/marker/12_1/节孝坊.jpg",
                    "gudao/marker/12_1/贞寿之门坊.jpg",
                    "gudao/marker/12_1/赞宪坊.jpg"
                ],
                "longitude": 118.336478,
                "latitude": 29.907115,
                "icon": "gudao/line/12/1.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.341342,
                "icon_latitude": 29.887821
            },
            {
                "s_id": "12_2",
                "name": "呈坎村古建筑群",
                "address": "徽州区呈坎镇呈坎村",
                "desc": "呈坎，古名龙溪，位于黄山东南麓。唐末，江西南昌府罗天真、罗天秩堂兄弟俩，举家迁入歙县，\"择地得西北四十里，地名龙溪，改名呈坎\"，呈坎古建筑群主要的建筑时代为明初至清末。呈坎汇集了不同建筑风格的亭、台、楼、阁、桥、井、祠、社及民居等，石雕、砖雕、木雕把古、大、美、雅的徽派建筑艺术在这里得到发挥，呈坎是中国保存的皖南民居、明清建筑最集中，最富特色，最具有观赏价值的村落。",
                "thumbs": [
                    "gudao/marker/12_2/呈坎.jpg"
                ],
                "longitude": 118.280803,
                "latitude": 29.914335,
                "icon": "gudao/line/12/2.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.280803,
                "icon_latitude": 29.914335
            },
            {
                "s_id": "12_3",
                "name": "灵山村古建筑群",
                "address": "徽州区呈坎镇灵山村",
                "desc": "灵山村古建筑群始建于后唐，已有千年历史，是徽州方氏主要聚居地。村内明清古建筑众多，建筑类别丰富，风格浓郁，展现了徽派古建筑的独特风貌。\n",
                "thumbs": [
                    "gudao/marker/12_3/灵山村.jpg"
                ],
                "longitude": 118.320847,
                "latitude": 29.916363,
                "icon": "gudao/line/12/3.png",
                "icon_scale": 113,
                "wh": 1.423,
                "icon_longitude": 118.320847,
                "icon_latitude": 29.916363
            }
        ]
    }
]